// Shared timezone options for the profile + settings pickers. US zones first,
// then other major zones. Used to stamp notifications in the user's local time.
export const TIMEZONES = [
  { value: "America/New_York", label: "Eastern Time (ET) — New York" },
  { value: "America/Chicago", label: "Central Time (CT) — Chicago" },
  { value: "America/Denver", label: "Mountain Time (MT) — Denver" },
  { value: "America/Phoenix", label: "Arizona (no DST) — Phoenix" },
  { value: "America/Los_Angeles", label: "Pacific Time (PT) — Los Angeles" },
  { value: "America/Anchorage", label: "Alaska Time — Anchorage" },
  { value: "Pacific/Honolulu", label: "Hawaii Time — Honolulu" },
  { value: "America/Toronto", label: "Canada Eastern — Toronto" },
  { value: "America/Mexico_City", label: "Mexico City" },
  { value: "Europe/London", label: "UK / Ireland — London" },
  { value: "Europe/Paris", label: "Central Europe — Paris" },
  { value: "Africa/Lagos", label: "West Africa — Lagos" },
  { value: "Asia/Dubai", label: "Gulf — Dubai" },
  { value: "Asia/Kolkata", label: "India — Kolkata" },
  { value: "Asia/Manila", label: "Philippines — Manila" },
  { value: "Asia/Tokyo", label: "Japan — Tokyo" },
  { value: "Australia/Sydney", label: "Australia Eastern — Sydney" },
];

// Friendly label for a saved IANA value (falls back to the raw value).
export function timezoneLabel(value) {
  if (!value) return "Eastern Time (ET) — New York (default)";
  return (TIMEZONES.find((t) => t.value === value) || {}).label || value;
}
